import { render, staticRenderFns } from "./PlantConfigurationTeamsPage.vue?vue&type=template&id=3fa097a8&"
import script from "./PlantConfigurationTeamsPage.vue?vue&type=script&lang=js&"
export * from "./PlantConfigurationTeamsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports